import React from 'react';
import { connect } from 'react-redux';
import UserRegist from '../../components/templates/UserRegist';
import { commonOperations } from '../../reducks/common';

const mapStateToProps = state => ({
  currentTheme: state.style.theme,
});
const mapDispatchToProps = {
  getAddressAction: commonOperations.doGetPost,
  doOpenDialog: commonOperations.doOpenDialog,
};

class App extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (<UserRegist
      {...this.props}
    />);
  }
}
const ContainerApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default ContainerApp;